const Headline1=(props)=> {
  return (
    <h1>{props.content}</h1>
 )
};
export default Headline1;